module.exports = __webpack_public_path__ + "static/media/img_customization.5712b1d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/img_customization.svg
// module id = 1086
// module chunks = 0